export const GET_LIST_TIPOS = 'cad-tipes/GET_LIST_TIPOS';
export const SET_LIST_TIPOS = 'cad-tipes/SET_LIST_TIPOS';
export const DELETE_TIPO = 'cad-tipes/DELETE_TIPO';
export const NEW_TYPE = 'cad-tipes/NEW_TIPO';
export const SELECT_TIPOS= 'cad-tipes/SELECT_TIPOS';
export const MODAL_BUDGET = 'advertising-budget/MODAL_BUDGET';
export const SET_ITEMS_TIPOS = 'cad-tipes/SET_ITEMS_TIPOS';
export const EDIT_ITEM_TIPOS = 'cad-tipes/EDIT_ITEM_TIPOS';
export const ADD_ITEM_BUDGET = 'advertising-budget/ADD_ITEM_BUDGET';
export const EDIT_TIPOS = 'cad-tipes/EDIT_TIPOS';
export const DELETE_ITEM_BUDGET = 'advertising-budget/DELETE_ITEM_BUDGET';
export const RESET_ITEMS_BUDGET = 'advertising-budget/RESET_ITEMS_BUDGET';


export const NEW_DESP = 'desp/NEW_DESP';
export const GET_LIST_DESP = 'desp/GET_LIST_DESP';
export const SET_LIST_DESP = 'desp/SET_LIST_DESP';
export const DELETE_DESP = 'desp/DELETE_DESP';
export const SET_ITEMS_DESP = 'desp/SET_ITEMS_DESP';
export const EDIT_DESP = 'desp/EDIT_DESP';

export default {
	EDIT_DESP,
	NEW_DESP,
	SET_ITEMS_DESP,
	DELETE_DESP,
	GET_LIST_DESP,
	SET_LIST_DESP,
	GET_LIST_TIPOS,
	SET_LIST_TIPOS,
	DELETE_TIPO,
	NEW_TYPE,
	SELECT_TIPOS,
	MODAL_BUDGET,
	SET_ITEMS_TIPOS,
	EDIT_ITEM_TIPOS,
	ADD_ITEM_BUDGET,
	EDIT_TIPOS,
	DELETE_ITEM_BUDGET,
	RESET_ITEMS_BUDGET,
};
